<template>
    <div class="global_banner" :class="[dark ? 'dark' : '']">
        <div class="degrade" :class="[dark ? 'dark' : '']"></div>
        <div 
            class="banner" 
            :class="[dark ? 'dark' : '']"
            :style="bannerStyle"
        ></div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        view: Boolean,
        data: Array,
        bannerPortal: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            userImage: require("@/assets/bg-course.png"),
            banner: null,
        };
    },
    computed: {
        ...mapState(['dark','token','listCoursesPortal', 'website']),
        ...mapState('portal', ['dataWebsitePortal2']),
        bannerStyle() {
            // Se não houver banner, usa imagem padrão
            let img = this.dataWebsitePortal2?.portalBannerFinalPath;
            if (!img) {
                img = this.userImage;
            }
            // Corrige caso a imagem não venha preenchida corretamente
            if (img && !/^https?:\/\//.test(img) && !img.startsWith('data:')) {
                // Se não for url absoluta, tenta ajustar o caminho
                img = process.env.VUE_APP_API_URL 
                    ? process.env.VUE_APP_API_URL + img 
                    : img;
            }
            return {
                backgroundImage: `url('${img}')`
            };
        }
    },
    methods: {
        goCourse(id) {
            window.location.href = `/aluno/curso/${id}`;
        },
        async getBanner() {

            if (this.dataWebsitePortal2?.portalBannerFinalPath) {
                this.banner = this.portalBannerFinalPath;
               console.log('Entrou no if');
            } else {
                console.log('Entrou no else');
                let source = this.dataWebsitePortal2?.portalBannerFinalPath;
                if (source && source.length && source[0].course) {
                    this.banner = source[0].course.imageFinalPath || source[0].course.imageFinalPath2 || null;
                    this.title = source[0].course.name || null;
                   
                } else {
                    this.banner = null;
                    this.title = null;
                }
            }
        }
    },
    watch: {
        data: {
            handler() {
                this.getBanner();
            },
            immediate: true,
            deep: true
        },
        listCoursesPortal: {
            handler() {
                this.getBanner();
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.getBanner();
    }
};
</script>

<style scoped>
.global_banner{
    position: relative;
}
.banner {
    position: relative;
    background: no-repeat;
    background-position: center right;
    height: 500px;
    max-width: 1600px;
    margin: 0 auto;
    background-size: cover;
    border-radius: 0 0 20px 20px;
    overflow: hidden;
}

.content {
    position: absolute;
    bottom: 0;
    width: 50%;
    z-index: 9;
    background-color: rgba(255, 255, 255, 0);
    top: 0%;
    display: flex;
    align-items: center;
    padding-left: 100px;
}
.content_layout {
    text-align: left;
}
.dark .content_layout p {
    color: #F3F3F3;
    font-family: Inter;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: 0.96px;
}
.content_layout p {
    color: #000000;
    font-family: Inter;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: 0.96px;
}
.content_layout label{
    color: rgba(0, 0, 0, 0.59);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 103.6%; /* 16.576px */
    letter-spacing: 0.16px;
    margin-bottom: 10px;
}
.dark .content_layout label{
    color: rgba(243, 243, 243, 0.59);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 103.6%; /* 16.576px */
    letter-spacing: 0.16px;
    margin-bottom: 10px;
}
button.btn-color {
    border-radius: 4px;
    background: var(--Turquesa, #1AC7D0);
    display: flex;
    padding: 12px 14px 12px 12px;
    align-items: center;
    gap: 8px;
    border: none;
    color: #ffffff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 103.6%;
    letter-spacing: 0.16px;
}
.dark button.btn-color {
    color: #000;
}
i.pi.pi-play {
    border: none;
}
@media only screen and (max-width: 600px) {
    .content {
        width: 100%;
        z-index: 9;
        background-color: rgba(255, 255, 255, 0);
        top: 0%;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }
    .banner {
        border-radius: 0 0 16px 16px;
        height: 500px;
        background-size: cover;
        background-position: left;
    }
}
</style>